import React from "react";
import UiMainWrapper from "../../components/common/UiMainWrapper";
import TopHeader from "../../components/header/TopHeader";
import quizBanner from "../../../../styles/img/quiz-banner.png";
import { UiBannerBottomBar } from "../../components/common/UiBannerBottomBar";
import KnowledgeInnerBanner from "./Views/KnowledgeInnerBanner";
import { UiContentCol, UiContentWr } from "../../components/common/UiPageElements";
import { UiCol, UiRowContainer, UiSingleRow } from "../../components/grid-container/GridContainer";
import Footer from "../../components/footer/Footer";
import { UiBlueBox } from "../../../_uiComponents/common/UiBlueBox";
import { Button } from "react-bootstrap";
import { QuestionLinks } from "../../../_uiComponents/common/QuestionLinks";
import { CircleTick } from "../../../../styles/img/svg/CircleTick";
import { UiQuestionWrapper } from "../../../_uiComponents/common/UiQuestionWrapper";
import { NeedAHelp } from "./Views/NeedAHelp";
import { FinalMarksBox } from "./Views/FinalMarksBox";
import { ResultFeedback } from "./Views/ResultFeedback";
import ToyotaInnerBanner from '../../../../styles/img/knowledge-inner-banner.png'
import ConfettiExplosion from 'react-confetti-explosion';

export const TemplateAssesmentPassed = (props) => {
    const [isExploding, setIsExploding] = React.useState(true);

    setTimeout(() => {
        setIsExploding(false);
    }, 4500);
    return (
        <>
            <UiMainWrapper>
                <TopHeader />

                <KnowledgeInnerBanner
                    innerBanner={ToyotaInnerBanner}
                    title="Q1 Product Quiz"
                    description="Is your knowledge up to scratch?"
                    className="sb-knowldg-inner-banner" />

                <UiBannerBottomBar
                    prevPage="Learn"
                    prevPageLink=""
                    currentPage="  Q1 Product Quiz"
                    currentPageLink="" />
                {isExploding && <ConfettiExplosion height="2320" width="2800" particleCount="800" duration="4500" />}

                <UiContentWr>
                    <UiRowContainer fluid="fluid" className="sb-mcq-template-page">
                        <UiContentCol>
                            <UiSingleRow>
                                <UiCol lg="3" className="sb-img-q-template-page__links">

                                    <UiBlueBox >
                                        <p>Questions Remaining</p>
                                        <h3>0</h3>
                                    </UiBlueBox>

                                    <QuestionLinks className="sb-green-links">
                                        <li className="active"><a href="#"> <CircleTick /> My Progress</a></li>
                                        <li className="active"><a href="#"><CircleTick />  Introduction</a></li>
                                        <li className="active"><a href="#"><CircleTick />  Introduction Section 2</a></li>
                                        <li className="active"><a href="#"><CircleTick />  Section 3</a></li>
                                        <li className="active"><a href="#"><CircleTick />  Section 4</a></li>
                                        <li className="active"><a href="#"><CircleTick />  Section 5</a></li>
                                        <li className="completed"><a href="#"> Assessment Complete</a></li>
                                    </QuestionLinks>

                                    <FinalMarksBox
                                        className="sb-passed"
                                        status="passed"
                                        title="Points earned"
                                        marks="2,000"
                                    />


                                </UiCol>
                                <UiCol lg="9" className="sb-img-q-template-page__content">
                                    <UiQuestionWrapper>

                                        <h3><span>Results: </span> 5 out of 5</h3>

                                        <h2 className="sb-result-passed"> Passed</h2>

                                        <UiSingleRow className="sb-quiz-details-cards">
                                            <UiCol lg="2">
                                                <div className="sb-quiz-details-cards__card">
                                                    <h4>Score:</h4>
                                                    <h3>45%</h3>
                                                </div>
                                            </UiCol>

                                            <UiCol lg="3">
                                                <div className="sb-quiz-details-cards__card">
                                                    <h4>Time to Complete:</h4>
                                                    <h3>45 mins</h3>
                                                </div>
                                            </UiCol>

                                            <UiCol lg="2">
                                                <div className="sb-quiz-details-cards__card">
                                                    <h4>Attempts:</h4>
                                                    <h3>1/3</h3>
                                                </div>
                                            </UiCol>

                                        </UiSingleRow>

                                        <ResultFeedback />

                                        <div className="row">
                                        <div className="col-4">
                                        <Button >Return to Programme</Button>
                                        </div></div>
                                    </UiQuestionWrapper>

                                </UiCol>
                            </UiSingleRow>
                        </UiContentCol>
                    </UiRowContainer>
                </UiContentWr>

                <NeedAHelp />

                <Footer />

            </UiMainWrapper>

        </>
    )
}